module.exports = __webpack_public_path__ + "static/media/Illustrations.99244a24.svg";